var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiSolutionGridElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 178.323 166.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_Solution_grid_element",
    d: "M2.484,57.457.649,114.442l3.626,45.647,30.936,1.443,126.739.812,14.176-2.9V142.707l2.845-91.864-.607-34.749L153.586-1.632,20.969-2.417,1.407-4.257Z",
    transform: "translate(-0.649 4.257)",
    fill: "#fef1d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSolutionGridElement);
export default __webpack_public_path__ + "static/media/UI_Solution_grid_element.9680ee091ef4223ca80d157fb023d831.svg";
export { ForwardRef as ReactComponent };